import {
  CompanyTabID,
  CompanyTabName,
  CompanyTabPosition,
  CompanyTabUUID,
  UpdateCompanyTabCacheKeys,
  UpdateCompanyTabGqlQuery
} from '../../companyTabsTypes';

import { useEdUpdateQuery } from '../../../common/reactQuery/hooks/useEdUpdateQuery';
import { ErrorType } from '../../../../utils/parseRequestError';

interface UpdateCompanyTabOptions<ItemType> {
  query: UpdateCompanyTabGqlQuery;
  cacheKeys?: UpdateCompanyTabCacheKeys;
  onSuccess?: (record: ItemType) => void;
}

export interface UpdateCompanyTabInput {
  uid: CompanyTabUUID | CompanyTabID;
  name?: CompanyTabName;
  content?: string;
  position?: CompanyTabPosition;
}

export type UpdateCompanyTabError = ErrorType;

const action = 'updateCompanyTab';

function useUpdateCompanyTab<UpdateCompanyTabRecordType = unknown>({
  query,
  cacheKeys,
  onSuccess
}: UpdateCompanyTabOptions<UpdateCompanyTabRecordType>) {
  const {
    updateQuery,
    updateQueryData,
    updateQueryError,
    updateQueryErrorMessage,
    updateQueryLoading,
    updateQueryReset
  } = useEdUpdateQuery<
    UpdateCompanyTabInput,
    UpdateCompanyTabRecordType,
    UpdateCompanyTabError,
    UpdateCompanyTabRecordType
  >({ action, query, cacheKeys, onSuccess });

  return {
    updateCompanyTab: updateQuery,
    updateCompanyTabData: updateQueryData,
    updateCompanyTabError: updateQueryError,
    updateCompanyTabErrorMessage: updateQueryErrorMessage,
    updateCompanyTabLoading: updateQueryLoading,
    updateCompanyTabReset: updateQueryReset
  };
}

export default useUpdateCompanyTab;
